import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-rows-per-page',
  templateUrl: './rows-per-page.component.html',
  styleUrls: ['./rows-per-page.component.css'],
  imports: [NgSelectComponent,FormsModule],
})
export class RowsPerPageComponent {

  @Input() pageSize = 10;
  @Input() pageSizeOptions: number[] = [10, 25, 50, 100];
  @Input() total = 0;
  @Input() pageIndex = 0;

  @Output() pageSizeChange = new EventEmitter<number>();

  onChange(event: any) {
    this.pageSizeChange.emit(+event);
  }

  get start() {
    return this.total === 0 ? 0 : (this.pageIndex - 1) * this.pageSize + 1;
  }

  get end() {
    const calcEnd = this.start + this.pageSize - 1;
    return calcEnd > this.total ? this.total : calcEnd;
  }
}
